<template>
  <div class="relative bg-white rounded-2xl shadow-md p-6 mx-auto space-y-2">
    <div class="flex justify-end">
      <StoreConfigurationStatusBadge :configuration-status="store.afterSalesServiceConfigStatus" />
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-2">
      <StackedField label="Atelier de réparation">
        <Selector
          v-if="editMode"
          id="repairWorkshop"
          name="repairWorkshop"
          :options="repairWorkshopOptions"
          v-model="formData.repairWorkshop"
        />
        <template v-else>{{ repairWorkshopLabel }}</template>
      </StackedField>
      <StackedField
        v-if="editMode ? formData.repairWorkshop : store.repairWorkshop || store.repairWorkshopEmail"
        label="Email atelier de réparation"
      >
        <FormField
          v-if="editMode"
          id="repairWorkshopEmail"
          name="repairWorkshopEmail"
          v-model="formData.repairWorkshopEmail"
          :placeholder="store.repairWorkshopEmail"
        />
        <template v-else>{{ store.repairWorkshopEmail || "—" }}</template>
      </StackedField>
    </div>
    <div class="flex flex-row-reverse gap-x-4">
      <template v-if="editMode">
        <SecondaryButton @click="editMode = false">Annuler</SecondaryButton>
        <SecondaryButton @click="submitEdit">Mettre à jour</SecondaryButton>
      </template>
      <template v-else>
        <SecondaryButton v-if="validationNeeded" @click="validate">Valider</SecondaryButton>
        <SecondaryButton v-if="validationNeeded" @click="reject">Refuser</SecondaryButton>
        <SecondaryButton @click="editMode = true">Modifier</SecondaryButton>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { StackedField, SecondaryButton } from "@estaly/ui";
import StoreConfigurationStatusBadge from "@/components/StoreConfigurationStatusBadge.vue";
import { FormField } from "@estaly/ui";
import { Selector } from "@estaly/ui";

export default {
  components: {
    StoreConfigurationStatusBadge,
    SecondaryButton,
    StackedField,
    FormField,
    Selector,
  },
  props: ["store", "isStoreSetup"],

  data: () => {
    return {
      editMode: false,
      formData: {
        repairWorkshop: false,
        repairWorkshopEmail: "",
      },
      repairWorkshopOptions: [
        { value: true, label: "Oui" },
        { value: false, label: "Non" },
      ],
    };
  },

  mounted() {
    const { afterSalesServiceConfigStatus, repairWorkshop, repairWorkshopEmail } = this.store;

    this.formData = {
      afterSalesServiceConfigStatus,
      repairWorkshop,
      repairWorkshopEmail,
    };
  },

  computed: {
    repairWorkshopLabel() {
      return this.store?.repairWorkshop ? "Oui" : "Non";
    },

    pendingValidation() {
      return this.store.afterSalesServiceConfigStatus === "pending_validation";
    },

    validationNeeded() {
      return this.isStoreSetup && this.pendingValidation && !this.editMode;
    },
  },

  watch: {
    "formData.repairWorkshop"(newValue) {
      if (!newValue) this.formData.repairWorkshopEmail = null;
    },
  },

  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("stores", ["updateAfterSalesService", "update"]),

    validate() {
      this.$emit("validate");
    },

    reject() {
      this.$emit("reject");
    },

    async submitEdit() {
      const response = this.isStoreSetup
        ? await this.updateAfterSalesService({ storeId: this.store.id, ...this.formData })
        : await this.update({ storeId: this.store.id, data: this.formData });
      if (!response?.success) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "Mise à jour effectuée",
      });
      this.$emit("updated");
      this.editMode = false;
    },
  },
};
</script>
